import { render, staticRenderFns } from "./BtnIconTip.vue?vue&type=template&id=53e8a6fa&"
import script from "./BtnIconTip.vue?vue&type=script&lang=js&"
export * from "./BtnIconTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports